import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'hypenation-tickets-quantity-component',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './quantity-component.component.html',
  styleUrl: './quantity-component.component.css',
})
export class QuantityComponentComponent {
  // Input to set the initial value of the counter.
  @Input() numberOfTickets = 0;
  @Input() disabled = false;

  // Output to notify the parent component of any changes.
  @Output() numberOfTicketsChange = new EventEmitter<number>();

  // Method to update the number of tickets when + or - button is clicked.
  updateNumberOfTickets(change: number) {
    // Don't update if disabled
    if (this.disabled) {
      return;
    }

    // Keep quantity bounded to avoid invalid values in parent flows.
    this.numberOfTickets = Math.max(1, (this.numberOfTickets || 1) + change);

    // Emit the change to the parent component
    this.numberOfTicketsChange.emit(this.numberOfTickets);
  }

  onInputChange(value: string): void {
    if (this.disabled) {
      return;
    }

    const parsed = Number(value);
    this.numberOfTickets = Number.isFinite(parsed)
      ? Math.max(1, Math.trunc(parsed))
      : 1;
    this.numberOfTicketsChange.emit(this.numberOfTickets);
  }
}
